import { Pipe, PipeTransform } from '@angular/core';
import { CwtAssetDescriptor } from '@cawita/core-front/asset';
import { Document } from '../../models';
import { KatchaAssetService } from './asset.service';

@Pipe({
    name: 'asset'
})
export class KatchaAssetPipe implements PipeTransform {

    constructor(private asset: KatchaAssetService) { }

    transform(asset: CwtAssetDescriptor | Document, isPrivate?: boolean, prefix?: string) {
        return this.asset.getAssetUrl(asset, isPrivate, prefix);
    }

}
